<template>
  <BaseForm formColor="panel panel-primary" formIcon="fa fa-edit" formSubtitulo="Relatório de análises"
            col-md="col-md-4" offset="offset-4">
    <template v-slot:inputForm>
      <form @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.tipo_relatorio"
                    inputId="tipo_relatorio"
                    :options="tipoRelatorio"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('tipo_relatorio')"
                />
                <label for="tipo_relatorio">
                  <strong>Tipo:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_inicio" v-model="dado.data_inicio" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataInicial" dateFormat="dd/mm/yyyy"/>
                <label for="data_inicio"><strong>Data inicial: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_fim" v-model="dado.data_fim" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataFim" dateFormat="dd/mm/yyyy"/>
                <label for="data_fim"><strong>Data final: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.corretor"
                    inputId="corretor"
                    :options="corretores"
                    optionLabel="nome"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="corretor"><strong>Corretor: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.cliente"
                    inputId="cliente"
                    :options="clientes"
                    optionLabel="razao_social"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="cliente"><strong>Cliente: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.fase"
                    inputId="fase"
                    :options="fase"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('fase')"
                />
                <label for="fase">
                  <strong>Fase:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.status"
                    inputId="status"
                    :options="status"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('status')"
                />
                <label for="status">
                  <strong>Status:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
        </div>
        <br>
      </form>
    </template>
  </BaseForm>
</template>

<script>

import {defineComponent} from "vue";
import BaseForm from "@/components/base/BaseForm.vue";
import {apiRequest, denormalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes"


export default defineComponent({
  name: "RelatorioAnalise",
  components: {
    BaseForm,
  },
  data() {
    return {
      corretores: [],
      clientes: [],
      dado: {
        tipo_relatorio: "A",
        data_inicio: null,
        data_fim: null,
        corretor: "",
        cliente: "",
        fase: "T",
        status: "T",
      },
      campoVazio: [],
      tipoRelatorio: [
        {label: 'ANÁLITICO', value: 'A'},
        {label: 'SINTÉTICO', value: 'S'}
      ],
      fase: [
        {label: 'TODOS', value: 'T'},
        {label: '1-CREDITO', value: '1'},
        {label: '2-IMÓVEL', value: '2'},
        {label: '3-FINANCIAMENTO', value: '3'},
        {label: '4-ENGENHARIA', value: '4'},
        {label: '5-CONTRATO', value: '5'},
      ],
      status: [
        {label: 'TODOS', value: 'T'},
        {label: 'ASSINADO', value: 'A'},
        {label: 'APROVADO', value: 'AP'},
        {label: 'CANCELADO', value: 'CA'},
        {label: 'CONDICIONAMENTO', value: 'C'},
        {label: 'EMITIDO', value: 'EM'},
        {label: 'EM ANÁLISE', value: 'E'},
        {label: 'REPROVADO', value: 'R'},

      ],
    }
  },
  methods: {
    async getCorretores() {
      const resultado = await apiRequest("GET", apiUrl.corretores.createList);
      if (resultado.success) {
        this.corretores = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getClientes() {
      const resultado = await apiRequest("GET", apiUrl.clientes.createList);
      if (resultado.success) {
        this.clientes = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitIncluirForm() {
      denormalizeDates(this.dado, ['data_inicio', 'data_fim']);
      const resultado = await apiRequest("POST", apiUrl.analises.relatorio, this.dado);
      if (resultado.success) {
        this.$router.push({
          path: '/relatorio',
          state: resultado.data
        });
      } else {
        this.$toastMessage("warn", "Atenção", resultado.error.detail);
        console.error("Erro:", resultado.error);
        this.campoVazio = Object.keys(resultado.error);
      }
    },
  },
  mounted() {
    this.getClientes();
    this.getCorretores();
    Inputmask("99/99/9999").mask(this.$refs.dataInicial.$el.querySelector("input"));
    Inputmask("99/99/9999").mask(this.$refs.dataFim.$el.querySelector("input"));
  }
})
</script>
